import React from 'react'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useErrorHandler, useSso } from './libs/web-client/utils/auth0/src'
import { setErrorMessage } from './redux/slices/authentication'
import { ModalContent, openModal } from './redux/slices/globalModal'
import { Routes } from './routing/routes'

export const App = () => {
    const dispatch = useDispatch()
    const handleAuthError = useCallback(
        error => {
            dispatch(setErrorMessage(error.message))
            dispatch(
                openModal({
                    content: ModalContent.SIGNUP,
                }),
            )
        },
        [dispatch],
    )

    const { isLoading } = useSso()
    useErrorHandler(handleAuthError)

    if (isLoading) {
        //TODO: show loading skeleton for auth - https://www.pivotaltracker.com/story/show/178079848
        return null
    }

    return <Routes />
}

export default App
